import React from 'react';
import { ReactComponent as StarFill } from '../../asset/icons/star-fill.svg'
import { ReactComponent as StarHalf } from '../../asset/icons/star-half.svg'
import { ReactComponent as Star } from '../../asset/icons/star.svg'

const ScoreStarsBox = ({ size, count }) => {
    count = count === undefined ? 0 : Math.min(5, count);   // handle numbers more than 5
    const stars = [];
    let index = 0;
    for (let i=0; i<Math.floor(count); i++) {
        stars.push(<StarFill key={index++} className="star_image"/>);
    }
    if (count !== Math.floor(count)) {
        stars.push(<StarHalf key={index++} className="star_image star_image--half"/>);
    }
    for (let i=index; i<5; i++) {
        stars.push(<Star key={index++} className="star_image star_image--empty"/>);
    }
    return (
        <div className={`stars_box ${size}`}>
            {
                stars
            }
        </div>
    );
};

export default ScoreStarsBox;
